import { render, staticRenderFns } from "./ProductDetailDesktop.vue?vue&type=template&id=1123ddeb&"
import script from "./ProductDetailDesktop.vue?vue&type=script&lang=js&"
export * from "./ProductDetailDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports